<template>
    <div class="c-a-rating" :class="{active: value > 0}">
        <span v-for="index in 5" :key="`rating-${index}`" class="c-a-rating__value" @click="updated(index)" :class="{selected: index == value}">
            <svg class="c-a-icon star c-a-rating__icon">
                <use :href="`/assets/icons/icons.svg#star`" :xlink:href="`/assets/icons/icons.svg#star`"></use>
            </svg>
            <svg class="c-a-icon star_border c-a-rating__icon">
                <use :href="`/assets/icons/icons.svg#star_border`" :xlink:href="`/assets/icons/icons.svg#star_border`"></use>
            </svg>
        </span>
    </div>
</template>
<script>
    import Icon from './AtomIcon.vue';

    export default {
        props: ['value'],
        data() {
            return {
                ratingValue:0
            }
        },
        computed:{
            rating:{
                get(){
                    return this.ratingValue;
                },
                set(value){
                    this.ratingValue = value;
                }
            }
        },
        methods:{
            updated(value){
                this.$emit('input', value);
            }
        }
    }
</script>

<style scoped>

.c-a-icon{
    width: 2.5rem;
    min-width: 2.5rem;
    height: 2.5rem;
}

span.c-a-rating__value{
    position:relative;
    width: 2.5rem;
    min-width: 2.5rem;
    height: 2.5rem;
}

span.c-a-rating__value .c-a-icon.star,
span.c-a-rating__value .c-a-icon.star_border{
    position:absolute;
    background:#fff;
    left:0;
    top:0;
}

span.c-a-rating__value .c-a-icon.star_border{

    z-index:99;
}

.c-a-rating:hover .c-a-icon.star_border,
.c-a-rating.active .c-a-icon.star_border,
.c-a-rating > span.c-a-rating__value:hover .c-a-icon.star_border,
.c-a-rating > span.c-a-rating__value.selected .c-a-icon.star_border{
    display:none;
}
.c-a-rating span.c-a-rating__value:hover ~ span.c-a-rating__value .c-a-icon.star_border,
.c-a-rating span.c-a-rating__value.selected ~ span.c-a-rating__value .c-a-icon.star_border{
   display:inline-block;
}
</style>


// WEBPACK FOOTER //
// src/views/components/atoms/AtomRatingSelect.vue